import { render, staticRenderFns } from "./DownloadAdmin.vue?vue&type=template&id=670d7c27&"
import script from "./DownloadAdmin.vue?vue&type=script&lang=js&"
export * from "./DownloadAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports